module.exports = __webpack_public_path__ + "img/2-4.938afcf2.png";